// Nine Lives '84 - gamepad input.
//
// Standard-mapping pads: left stick or d-pad moves, A jumps, X is the
// action button, down on the stick or d-pad is down. Jump and action are
// edge-triggered like the keyboard.

import { K_ACTION, K_DOWN, K_JUMP, K_LEFT, K_PAUSE, K_RIGHT, K_UP } from '../sim/constants';

export class GamepadInput {
  private prevJump = false;
  private prevAction = false;
  private prevPause = false;
  /** True once any pad has been seen; used to show pad hints. */
  connected = false;

  private unavailable = false;

  poll(): number {
    if (this.unavailable) return 0;
    let pads: (Gamepad | null)[];
    try {
      pads = typeof navigator !== 'undefined' && navigator.getGamepads ? navigator.getGamepads() : [];
    } catch {
      // Embedded frames without the gamepad permission throw here.
      this.unavailable = true;
      return 0;
    }
    let keys = 0;
    let jump = false;
    let action = false;
    let pause = false;
    for (const pad of pads) {
      if (!pad) continue;
      this.connected = true;
      const b = (i: number): boolean =>
        !!pad.buttons[i] && (pad.buttons[i].pressed || pad.buttons[i].value > 0.5);
      const ax = pad.axes[0] ?? 0;
      const ay = pad.axes[1] ?? 0;
      if (ax < -0.5 || b(14)) keys |= K_LEFT;
      if (ax > 0.5 || b(15)) keys |= K_RIGHT;
      if (ay > 0.5 || b(13)) keys |= K_DOWN;
      if (b(0) || ay < -0.5 || b(12)) {
        jump = true;
        keys |= K_UP;
      }
      if (b(2) || b(1)) action = true;
      if (b(9)) pause = true;
    }
    if (jump && !this.prevJump) keys |= K_JUMP;
    if (action && !this.prevAction) keys |= K_ACTION;
    if (pause && !this.prevPause) keys |= K_PAUSE;
    this.prevJump = jump;
    this.prevAction = action;
    this.prevPause = pause;
    return keys;
  }
}
